import * as React from 'react';
import { Box } from '@mui/material';
import { connect } from "react-redux";
import { loginPartner } from '../../app/store/actions/authActions';
import { Navigate } from "react-router-dom";
import { MainInput, MainPassword } from '../../app/components/Styles';
import { MarketingFormPage, MarketingButton } from '../../app/components/marketing';

export const PartnerLogin = ({ loginPartner, user, token, isLoading }) => {
    if (user) {
        const role = token.split(" ")[0];
        return (<Navigate to={`/${role}`} replace />);
    }

    const handleSubmit = (event) => {
        event.preventDefault();
        const data = new FormData(event.currentTarget);
        loginPartner({
            email: data.get('email'),
            password: data.get('password'),
        });
    };

    return (
        <MarketingFormPage
            maxWidth="sm"
            title="Partner login"
            subtitle="Manage your hosted events"
            loading={isLoading}
        >
            <Box component="form" onSubmit={handleSubmit} sx={{ mt: 1, width: '100%' }}>
                <MainInput
                    margin="normal"
                    required
                    fullWidth
                    id="email"
                    label="Email"
                    name="email"
                    type="email"
                    autoComplete="email"
                    autoFocus
                />
                <MainPassword
                    margin="normal"
                    required
                    fullWidth
                    name="password"
                    label="Password"
                    type="password"
                    id="password"
                    autoComplete="current-password"
                />
                <MarketingButton type="submit" fullWidth sx={{ mt: 3, mb: 2 }}>
                    Sign in
                </MarketingButton>
            </Box>
        </MarketingFormPage>
    );
};

const mapStateToProps = (state) => ({
    user: state?.auth?.user,
    token: state?.auth?.token,
    isLoading: state?.auth?.isLoading,
});

const mapDispatchToProps = { loginPartner };

export default connect(mapStateToProps, mapDispatchToProps)(PartnerLogin);
